export default __webpack_public_path__ + "static/media/sea-freight.be23fdbd.svg";